// src/hooks/usePreserveCallback.ts
import { useEffect, useMemo, useRef } from "react";
function usePreserveCallback(callback) {
  const ref = useRef(callback);
  useEffect(() => {
    ref.current = callback;
  }, [callback]);
  return useMemo(() => {
    return (...args) => {
      ref.current?.(...args);
    };
  }, [ref]);
}

export {
  usePreserveCallback
};
